import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, concat } from '@apollo/client';
import {
	IirisIdentityKey,
	getIirisCookie,
	getLocalStorageValue
} from '../helpers/authenticationHelper';

const graphQLEndpoint = new HttpLink({ uri: `${import.meta.env.VITE_BEACON_API_URL}/graphql` });

// const graphQLEndpoint = new HttpLink({
// 	uri: `${import.meta.env.VITE_BEACON_API_URL}/graphql`,
// 	credentials: 'include'
// });

const auhtMiddleware = new ApolloLink((operation, forward) => {
	operation.setContext({
		headers: {
			authorization: getIirisCookie() || '',
			email: getLocalStorageValue(IirisIdentityKey.USER_EMAIL) || ''
		}
	});
	return forward(operation);
});

export const apolloClient = new ApolloClient({
	link: concat(auhtMiddleware, graphQLEndpoint),
	cache: new InMemoryCache({ addTypename: false })
});
